import DownloadSiHaDocumentationRequestModelBase from '../_generated/modelBases/download-si-ha-documentation-request-model-base';

export default class DownloadSiHaDocumentationRequestModel extends DownloadSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
